<template>
  <v-dialog v-model="show">
    <v-card class="mt-2">
      <v-card-title primary-title>
        <span class="headline mb-0">B/L確認者</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save">{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="back">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.bu.name') +
                      $t('app.validator.messages.required'),
                ]"
                return-object
                :url="`divisions/kv?type=BU&companyId=${companyId}`"
                v-model="query.bu"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="事業部"
                return-object
                :url="
                  `divisions/kv?type=DEPARTMENT&companyId=${companyId}&buId=${query.bu &&
                    query.bu.value}`
                "
                v-model="query.department"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.productCode')"
                return-object
                url="products/kv"
                v-model="query.product"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-select
                :items="$store.state.sku_classifications"
                clearable
                item-text="text"
                item-value="value"
                label="部品区分"
                return-object
                v-model="query.classification"
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="B/L確認担当1"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.blDirector1Id"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="B/L確認担当2"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.blDirector2Id"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="B/L確認担当3"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.blDirector3Id"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="B/L確認担当4"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.blDirector4Id"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="B/L確認担当5"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.blDirector5Id"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="B/L確認担当6"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.blDirector6Id"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="B/L確認担当7"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.blDirector7Id"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="B/L確認担当8"
                return-object
                url="employees/kv?types=SHARP,SJL"
                v-model="query.blDirector8Id"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['companyId', 'accRepeat'],
  data() {
    return {
      query: {},
      show: false,
      buUrl: `divisions/kv?type=BU&&companyId=${this.companyId}`,
      departmentUrl: `divisions/kv?type=DEPARTMENT&&companyId=${
        this.companyId
      }`,
      employeeUrl: `employees/kv?companyId=${this.companyId}`,
      valid: false,
      acc: [],
    }
  },
  methods: {
    popup(id, accId) {
      this.$http.get(`/companies/${id}/accs/${accId}`).then((res) => {
        this.acc = res.data
        this.initData()
        this.show = true
      })
    },
    save() {
      if (this.accRepeat(this.query)) return
      this.$http
        .put(`/companies/${this.acc.id}/edit-bl-acc`, {
          buId: this.getValue(this.query.bu),
          departmentId: this.getValue(this.query.department),
          productCode: this.getValue(this.query.product),
          classificationId: this.getValue(this.query.classification),
          blDirector1Id: this.getValue(this.query.blDirector1Id),
          blDirector2Id: this.getValue(this.query.blDirector2Id),
          blDirector3Id: this.getValue(this.query.blDirector3Id),
          blDirector4Id: this.getValue(this.query.blDirector4Id),
          blDirector5Id: this.getValue(this.query.blDirector5Id),
          blDirector6Id: this.getValue(this.query.blDirector6Id),
          blDirector7Id: this.getValue(this.query.blDirector7Id),
          blDirector8Id: this.getValue(this.query.blDirector8Id),
        })
        .then(() => {
          this.$emit('refresh')
          this.show = false
        })
    },
    getValue(data) {
      return data && data.value
    },
    back() {
      this.query = {}
      this.show = false
    },
    initData() {
      this.$set(this.query, 'bu', {
        value: this.acc.buId,
        text: this.acc.buName,
      })
      this.$set(this.query, 'department', {
        value: this.acc.departmentId,
        text: this.acc.departmentName,
      })
      this.$set(this.query, 'product', {
        value: this.acc.productCode,
        text: this.acc.productName,
      })
      this.$set(this.query, 'classification', {
        value: this.acc.classificationId,
        text: this.acc.classificationName,
      })
      this.$set(this.query, 'blDirector1Id', {
        value: this.acc.blDirector1Id,
        text: this.acc.blDirector1Name,
      })
      this.$set(this.query, 'blDirector2Id', {
        value: this.acc.blDirector2Id,
        text: this.acc.blDirector2Name,
      })
      this.$set(this.query, 'blDirector3Id', {
        value: this.acc.blDirector3Id,
        text: this.acc.blDirector3Name,
      })
      this.$set(this.query, 'blDirector4Id', {
        value: this.acc.blDirector4Id,
        text: this.acc.blDirector4Name,
      })
      this.$set(this.query, 'blDirector5Id', {
        value: this.acc.blDirector5Id,
        text: this.acc.blDirector5Name,
      })
      this.$set(this.query, 'blDirector6Id', {
        value: this.acc.blDirector6Id,
        text: this.acc.blDirector6Name,
      })
      this.$set(this.query, 'blDirector7Id', {
        value: this.acc.blDirector7Id,
        text: this.acc.blDirector7Name,
      })
      this.$set(this.query, 'blDirector8Id', {
        value: this.acc.blDirector8Id,
        text: this.acc.blDirector8Name,
      })
    },
  },
}
</script>
